import type { AxiosRequestConfig, AxiosResponse } from "axios";
import axios from "axios";
import axiosRetry from "axios-retry";
import {
  reqErrHandler,
  reqHandler,
  resErrHandler,
  resHandler
} from "@util/net/interceptors";
import { REQUEST_TIMEOUT } from "@util/config";
import {
  getRegionFromUrl,
  getBrand,
  getEcRenewalImageRatio
} from "@util/common";
import { convertRegionName } from "@util/country";
import store from "../../redux/store";

const instance = axios.create({
  timeout: REQUEST_TIMEOUT,
  headers: {
    "x-fr-clientid": `${getBrand().toLowerCase()}.${convertRegionName(
      getRegionFromUrl()
    )}.stylehint-web`
  }
});
axiosRetry(instance, {
  retries: 2,
  retryDelay: (retryCount) => retryCount * 1000
});
// add interceptors
instance.interceptors.request.use(reqHandler, reqErrHandler);
instance.interceptors.response.use(resHandler, resErrHandler);
const get = async (
  url: string,
  config?: AxiosRequestConfig
): Promise<AxiosResponse> => {
  const { region, language } = store.getState().app;
  const response = await instance.get(
    `/${region}/api/commerce/v5/${language}${url}`,
    config
  );
  return response;
};

const getFavoritePopup = async (
  url: string,
  params?: any,
  config?: AxiosRequestConfig
): Promise<AxiosResponse> => {
  const { region, language } = store.getState().app;
  const response = await instance.get(
    `/${region}/api/commerce/v5/${language}/products/${
      params.productId
    }/price-groups/${
      params.priceGroup
    }${url}?allL2s=true&imageRatio=${getEcRenewalImageRatio()}`,
    config
  );
  return response;
};

const getFavoritePopupForGuApp = async (
  url: string,
  params?: any,
  config?: AxiosRequestConfig
): Promise<AxiosResponse> => {
  const { region, language } = store.getState().app;
  const response = await instance.get(
    `/${region}/api/commerce/v5/${language}/products/${
      params.productId
    }/price-groups/${
      params.priceGroup
    }${url}?&imageRatio=${getEcRenewalImageRatio()}`,
    config
  );
  return response;
};

const post = async (
  url: string,
  params?: any,
  config?: AxiosRequestConfig
): Promise<AxiosResponse> => {
  const { region, language } = store.getState().app;
  const response = await instance.post(
    `/${region}/api/commerce/v5/${language}${url}`,
    params,
    config
  );
  return response;
};

const del = async (
  url: string,
  config?: AxiosRequestConfig
): Promise<AxiosResponse> => {
  const { region, language } = store.getState().app;
  const response = await instance.delete(
    `/${region}/api/commerce/v5/${language}${url}`,
    config
  );
  return response;
};

export default {
  get,
  getFavoritePopup,
  getFavoritePopupForGuApp,
  del,
  post
};
